<style lang="sass">

    @import ../../common/styles/mixins

    .paragraph-youtube

        width: calc(100% - 2rem)
        height: calc(100% - 2rem)
        background-size: cover
        background-position: center
        position: relative
        box-shadow: 0 0.5rem 1rem 0.5rem rgba(50,50,50,0.1)

        +media("<=tablet")
            width: 100%
            height: 15rem

        +media("<phone")
            height: 13rem
            width: 100%

        &:after
            +filter
            +media("<phone")
                opacity: 0

        picture
            img
                object-fit: cover
                max-width: 100%
                height: auto

        .iframe
            width: 100%
            height: 100%

        .button
            position: absolute
            right:  -2rem
            bottom: -2.5rem
            z-index: 2

            +media("<=tablet")
                right: -1rem

            +media("<phone")
                right: auto

</style>


<script>

    import URI from 'urijs'

    export default {

        props: [ "url" ],

        mounted: function() {
            const tacDiv = this.$refs["tac-container"];
            tacDiv.setAttribute("videoID", this.youtubeVideoId);
        },

        computed: {
            youtubeVideoId: function() {
                let string = URI(this.url).search();
                let split = string.split("v=");
                return split[1];
            }
        }

    }

</script>
